import { Box, Container } from '@mui/material';
import { ReactNode } from 'react';
import { useIntl } from 'react-intl';

import { Routes } from 'constants/routes.constants';
import { useEmbedded } from 'hooks/useEmbedded';

import LinkUnstyled from 'components/@common/LinkUnstyled';
import LogoNofomo from 'components/@navigation/LogoNofomo';

interface Props {
  children: ReactNode;
}

const GenericPageLayout = ({ children }: Props) => {
  const { isEmbedded } = useEmbedded();
  const intl = useIntl();

  return (
    <Container
      sx={{
        mt: { xs: 2, md: 3 },
        mb: 4,
        display: 'flex',
        flexDirection: 'column',
        alignItems: 'center',
        flex: { xs: 1, md: 0 },
      }}
      maxWidth="sm"
    >
      {isEmbedded ? (
        <LogoNofomo sx={{ mb: { xs: 5, md: 9 } }} />
      ) : (
        <Box
          aria-label={intl.formatMessage({
            id: 'navigation.home',
            defaultMessage: 'Home',
          })}
          component={LinkUnstyled}
          href={Routes.Home}
          sx={{
            display: 'flex',
          }}
        >
          <LogoNofomo sx={{ mb: { xs: 5, md: 9 } }} />
        </Box>
      )}
      {children}
    </Container>
  );
};

export default GenericPageLayout;
